/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.31",
    versionName: "0.2.0-nightly.2025.12.31",
    versionChannel: "nightly",
    buildDate: "2025-12-31T00:07:58.140Z",
    commitHash: "2c4f40041874c426a9c807e593983db31a4a44cd",
};
